<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">优惠时段管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item>
                    <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search"
                               @click="submitQuery(1)">刷新
                    </el-button>
                    <el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'discountTimeDetail' })">
                        添加
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>时间段</span>
        </div>
        <div class="content-data" v-if="times && 0 < times.length">
            <el-table highlight-current-row :data="times" border ref="multipleTable"  >

                <el-table-column type="index" width="50" label="序号"/>
                <el-table-column align="center" label="开始时间" prop="startTime"/>
                <el-table-column align="center" label="结束时间" prop="endTime"/>
                <el-table-column align="center" fixed="right" label="操作" width="500px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'discountTimeDetail', query: { id: scope.row.id }})">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="seckillTime/pageSeckillTime" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            times: [],

            query: {},


            dynamicPath: config.dynamicResourcePath,
        }
    },
    created() {
        var _this = this;

    },
    methods: {
        fillData(response) {
            this.times = response.items || [];
        },
        submitQuery(_num) {
            var _this = this;
            _this.members = [];
            _this.$refs.pager.gotoPage(_num);
        },
    },
}
</script>
<style scoped>
</style>